const getChallengeTypes = () => {
  return [
    { name: 'Conversational', value: 'conversational' },
    { name: 'Activity', value: 'activity' },
    { name: 'Trivia', value: 'trivia' },
    { name: 'Race', value: 'race' },
    { name: 'Kit', value: 'kit' },
    { name: 'Tasting', value: 'tasting' },
    { name: 'Puzzle', value: 'puzzle' },
    { name: 'Movie', value: 'movie' },
    { name: 'Music', value: 'music' },
  ];
};

export { getChallengeTypes };
